import { Component } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Textarea } from '../../../textarea/textarea.component';
import { InputFormFieldAdapter } from '../../adapters/input-form-field.adapter';
import { TextareaFormField } from '../../auto-form.type';

@Component({
  selector: 'app-textarea-form-field',
  standalone: true,
  imports: [Textarea],
  templateUrl: './textarea-form-field.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TextareaFormFieldComponent,
      multi: true,
    },
  ],
})
export class TextareaFormFieldComponent extends InputFormFieldAdapter<
  TextareaFormField<any>
> {}
